import React from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import log from '../utils/log';
import {getIsShowingProject} from '../../reducers/project-state';
import windowManager from '../../addons/window-system/window-manager';

const PACKAGER_URL = 'https://packager.warp.kokodev.cc';
// Use only the origin for origin checks:
const PACKAGER_ORIGIN = new URL(PACKAGER_URL).origin;

let packagerWindow = null;

const PackagerIntegrationHOC = function (WrappedComponent) {
    class PackagerIntegrationComponent extends React.Component {
        constructor (props) {
            super(props);
            this.handleClickPackager = this.handleClickPackager.bind(this);
            this.handleMessage = this.handleMessage.bind(this);
        }
        componentDidMount () {
            console.log('[PACKAGER] componentDidMount: adding message listener');
            window.addEventListener('message', this.handleMessage);
        }
        componentWillUnmount () {
            console.log('[PACKAGER] componentWillUnmount: removing message listener');
            window.removeEventListener('message', this.handleMessage);
        }
        handleClickPackager () {
            console.log('[PACKAGER] handleClickPackager, canOpenPackager =', this.props.canOpenPackager);

            if (!this.props.canOpenPackager) {
                console.log('[PACKAGER] cannot open, canOpenPackager=false');
                return;
            }

            if (packagerWindow && packagerWindow.isVisible) {
                console.log('[PACKAGER] window already open, bringing to front');
                packagerWindow.bringToFront();
                return;
            }

            packagerWindow = windowManager.createWindow({
                title: 'Packager',
                width: 700,
                height: 700,
                minWidth: 600,
                minHeight: 400,
                x: Math.max(50, (window.innerWidth - 700) / 2),
                y: Math.max(50, (window.innerHeight - 700) / 2),
                onClose: () => {
                    console.log('[PACKAGER] window closed');
                    packagerWindow = null;
                }
            });

            const container = packagerWindow.getContentElement();
            container.style.padding = '0';
            container.style.overflow = 'hidden';

            const iframe = document.createElement('iframe');
            iframe.style.width = '100%';
            iframe.style.height = '100%';
            iframe.style.border = 'none';
            iframe.style.borderRadius = '0 0 8px 8px';
            iframe.src = `${PACKAGER_URL}/?import_from=${location.origin}`;
            console.log('[PACKAGER] iframe src =', iframe.src, 'location.origin =', location.origin);

            container.appendChild(iframe);
            packagerWindow.show();
        }
        handleMessage (e) {
            console.log('[PACKAGER] handleMessage raw', e);

            if (e.origin !== PACKAGER_ORIGIN) {
                console.log(
                    '[PACKAGER] ignored: origin mismatch',
                    'e.origin =', e.origin,
                    'expected =', PACKAGER_ORIGIN
                );
                return;
            }

            console.log('[PACKAGER] origin OK, canOpenPackager =', this.props.canOpenPackager);
            if (!this.props.canOpenPackager) {
                console.log('[PACKAGER] ignored: canOpenPackager=false');
                return;
            }

            const packagerData = e.data && e.data.p4;
            console.log('[PACKAGER] p4 data =', packagerData);

            if (!packagerData || packagerData.type !== 'ready-for-import') {
                console.log('[PACKAGER] ignored: type is not ready-for-import');
                return;
            }

            console.log('[PACKAGER] got ready-for-import, sending start-import');
            e.source.postMessage({
                p4: {
                    type: 'start-import'
                }
            }, e.origin);

            console.log('[PACKAGER] calling saveProjectSb3("arraybuffer")');
            this.props.vm.saveProjectSb3('arraybuffer')
                .then(buffer => {
                    const name = `${this.props.reduxProjectTitle}.sb3`;
                    console.log(
                        '[PACKAGER] saveProjectSb3 resolved, byteLength =',
                        buffer && buffer.byteLength,
                        'name =', name
                    );
                    e.source.postMessage({
                        p4: {
                            type: 'finish-import',
                            data: buffer,
                            name
                        }
                    }, e.origin, [buffer]);
                    console.log('[PACKAGER] finish-import posted');
                })
                .catch(err => {
                    console.error('[PACKAGER] saveProjectSb3 error', err);
                    e.source.postMessage({
                        p4: {
                            type: 'cancel-import'
                        }
                    }, e.origin);
                    console.log('[PACKAGER] cancel-import posted');
                });
        }
        render () {
            const {
                /* eslint-disable no-unused-vars */
                canOpenPackager,
                /* eslint-enable no-unused-vars */
                ...props
            } = this.props;
            return (
                <WrappedComponent
                    onClickPackager={this.handleClickPackager}
                    {...props}
                />
            );
        }
    }
    PackagerIntegrationComponent.propTypes = {
        canOpenPackager: PropTypes.bool,
        reduxProjectTitle: PropTypes.string,
        vm: PropTypes.shape({
            saveProjectSb3: PropTypes.func
        })
    };
    const mapStateToProps = state => ({
        canOpenPackager: getIsShowingProject(state.scratchGui.projectState.loadingState),
        reduxProjectTitle: state.scratchGui.projectTitle,
        vm: state.scratchGui.vm
    });
    const mapDispatchToProps = () => ({});
    return connect(
        mapStateToProps,
        mapDispatchToProps
    )(PackagerIntegrationComponent);
};

export {
    PackagerIntegrationHOC as default
};
